import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { fields } from "../../common/lib/redux-fields";
import { ValidationError } from "../../common/lib/validation";
import { hashFromObj } from "../../common/lib/utils/hash";

import {
  Container,
  Row,
  Col,
  Form as BootstrapForm,
  FormGroup,
  Label,
  FormFeedback,
  Button
} from "reactstrap";

import { create, get, update } from "../../common/offer/actions";
import { clearError, clearForm } from "../../common/offer/actions";

import {
  getAll as getAllAgencies,
  setSearchField as setSearchFieldAgency
} from "../../common/agency/actions";

import ButtonWithLoader from "../../browser/components/Form/ButtonWithLoader";
import Input from "../../browser/components/Form/Input";

import moment from "moment";

moment.locale("pl");

const formFields = [
  "agencyUID",
  "agencyName",
  "agencyEmail",
  "agencyPhoneNumber",
  "country",
  "city",
  "code",
  "sex",
  "startDate",
  "title",
  "shortDesc",
  "mainDesc",
  "healthDesc",
  "whenDesc",
  "clientReqDesc",
  "offerDesc",
  "isPromoted",
  "isDeleted"
];

const formPath = "offerForm";

class Form extends React.Component {
  constructor() {
    super();

    this.create = this.create.bind(this);
    this.update = this.update.bind(this);
    this.clearError = this.clearError.bind(this);
  }

  componentDidMount() {
    const {
      params,
      get,
      editForm,
      fields,
      clearForm,
      getAllAgencies
    } = this.props;

    fields.$reset();
    clearForm();
    getAllAgencies();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  async create(e) {
    const { fields, appPath } = this.props;
    const { create } = this.props;
    e.preventDefault();
    const values = fields.$values();

    const rs = await create(values);

    if (rs && rs.status === 200) {
      fields.$reset();
      this.redirect(`${appPath}/offers/edit/${rs.body.uid}`);
    }
  }

  async update(e) {
    const { fields, params } = this.props;
    const { update, get, clearForm } = this.props;
    e.preventDefault();
    const values = fields.$valuesChanged();

    if (Object.keys(values).length > 0) {
      values.uid = params.uid;

      const rs = await update(values);

      if (rs && (rs.status === 200 || rs.status === 204)) {
        await get({ uid: params.uid });
        fields.$reset();
      }
    }
  }

  clearError(field) {
    const { clearError } = this.props;

    clearError(field);
  }

  render() {
    const {
      apiHost,
      fields,
      form,
      editForm,
      agencyMap,
      agencyResults,
      agencyMeta,
      obj,
      setSearchFieldAgency
    } = this.props;

    const dirty = Object.keys(fields.$valuesChanged()).length > 0;
    const result =
      agencyResults &&
      agencyResults.get(hashFromObj(agencyMeta && agencyMeta.toJS()));

    return (
      <BootstrapForm onSubmit={editForm ? this.update : this.create} noValidate>
        <Container>
          <Row>
            <Col xs="6">
              <Input
                field="agencyUID"
                title="Agencja"
                type="react-select-async"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "agencyUID")}
                map={agencyMap}
                result={result}
                formPath={formPath}
                entity="agencies"
                loadOptions={v => {
                  setSearchFieldAgency("name", v);
                }}
                staticField={editForm}
                autoFocus
                {...fields.agencyUID}
              />
              <Input
                field="agencyName"
                title="Nazwa agencji"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "agencyName")}
                {...fields.agencyName}
              />
              <Input
                field="agencyEmail"
                title="Email agencji"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "agencyEmail")}
                {...fields.agencyEmail}
              />
              <Input
                field="agencyPhoneNumber"
                title="Telefon agencji"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "agencyPhoneNumber")}
                {...fields.agencyPhoneNumber}
              />
              <Input
                field="country"
                title="Kraj"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "country")}
                {...fields.country}
              />
              <Input
                field="city"
                title="Miasto"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "city")}
                {...fields.city}
              />
              <Input
                field="code"
                title="Kod"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "code")}
                {...fields.code}
              />
              <Input
                field="sex"
                title="Płeć"
                type="select"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "sex")}
                {...fields.sex}
              >
                <option>mężczyzna</option>
                <option>kobieta</option>
                <option>inne</option>
              </Input>
              <Input
                field="startDate"
                title="Data rozpoczęcia"
                type="date"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "startDate")}
                formPath={formPath}
                {...fields.startDate}
              />
              <Input
                field="isPromoted"
                title="Promowana"
                type="checkbox"
                loading={form.get("loading")}
                checked={fields.isPromoted.value}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "isPromoted")}
                {...fields.isPromoted}
              />
              <Input
                field="isDeleted"
                title="Skasowana"
                type="checkbox"
                loading={form.get("loading")}
                checked={fields.isDeleted.value}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "isDeleted")}
                {...fields.isDeleted}
              />
            </Col>
            <Col xs="6">
              <Input
                field="title"
                title="Tytuł"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "title")}
                {...fields.title}
              />
              <Input
                field="shortDesc"
                title="Krótki opis"
                type="textarea"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "shortDesc")}
                {...fields.shortDesc}
              />
              <Input
                field="mainDesc"
                title="Główny opis"
                type="textarea"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "mainDesc")}
                {...fields.mainDesc}
              />
              <Input
                field="healthDesc"
                title="Opis zdrowia"
                type="textarea"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "healthDesc")}
                {...fields.healthDesc}
              />
              <Input
                field="whenDesc"
                title="Opis czasu wyjazdu"
                type="textarea"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "whenDesc")}
                {...fields.whenDesc}
              />
              <Input
                field="clientReqDesc"
                title="Opis wymagań"
                type="textarea"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "clientReqDesc")}
                {...fields.clientReqDesc}
              />
              <Input
                field="offerDesc"
                title="Opis oferty"
                type="textarea"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "offerDesc")}
                {...fields.offerDesc}
              />
            </Col>
            <ButtonWithLoader
              className="button-loader"
              size="lg"
              color={dirty ? "warning" : "success"}
              text={editForm ? "Zapisano" : "Wprowadź dane"}
              isLoading={form.get("loading") || form.get("fileLoading")}
              loadingText={"Zapisuję zmiany..."}
              isDirty={dirty}
              dirtyText={editForm ? "Zapisz zmiany" : "Dodaj ofertę"}
            />
          </Row>
        </Container>
      </BootstrapForm>
    );
  }
}

Form.contextTypes = {
  router: React.PropTypes.object.isRequired
};

Form = fields(Form, {
  path: formPath,
  fields: formFields,
  getInitialState: ({ obj, editForm }) => {
    return {
      agencyUID: editForm ? obj.get("agencyUID") : "",
      agencyName: editForm ? obj.get("agencyName") : "",
      agencyEmail: editForm ? obj.get("agencyEmail") : "",
      agencyPhoneNumber: editForm ? obj.get("agencyPhoneNumber") : "",
      country: editForm ? obj.get("country") : "",
      city: editForm ? obj.get("city") : "",
      code: editForm ? obj.get("code") : "",
      sex: editForm ? obj.get("sex") : "mężczyzna",
      startDate: editForm ? obj.get("startDate") : moment().toISOString(),
      title: editForm ? obj.get("title") : "",
      shortDesc: editForm ? obj.get("shortDesc") : "",
      mainDesc: editForm ? obj.get("mainDesc") : "",
      healthDesc: editForm ? obj.get("healthDesc") : "",
      whenDesc: editForm ? obj.get("whenDesc") : "",
      clientReqDesc: editForm ? obj.get("clientReqDesc") : "",
      offerDesc: editForm ? obj.get("offerDesc") : "",
      isPromoted: editForm ? obj.get("isPromoted") * 1 : false,
      isDeleted: editForm ? obj.get("isDeleted") * 1 : false
    };
  }
});

Form = connect(
  state => ({
    apiHost: state.config.apiHost,
    form: state.offer.form,
    fields: state.fields,
    appPath: state.config.appPath,
    agencyMap: state.agency.map,
    agencyMeta: state.agency.meta,
    agencyResults: state.agency.results
  }),
  {
    create,
    clearError,
    clearForm,
    get,
    update,
    getAllAgencies,
    setSearchFieldAgency
  }
)(Form);

export { Form, formFields };



// WEBPACK FOOTER //
// ./src/browser/offer/Form.js